/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Filter by one or more investor signature statuses
 */
export enum DocumentWorkflowInstanceSignatureStatus {
    CREATED = 'CREATED',
    PENDING_SIGNATURE = 'PENDING_SIGNATURE',
    SIGNED = 'SIGNED',
    COMPLETED = 'COMPLETED',
    DECLINED = 'DECLINED',
    EXPIRED = 'EXPIRED',
    ERROR = 'ERROR',
    WAITING_FOR_WITNESS_SIGNATURES = 'WAITING_FOR_WITNESS_SIGNATURES',
    CLOSED_WITHOUT_SIGNATURE = 'CLOSED_WITHOUT_SIGNATURE',
}
